const variables = {
  state: {
    mapbox: {
      accessToken: '',
      defaultOptions: {
        style: 'https://api.maptiler.com/c/element/styles/element-light/style.json?key=EiCgsIZ0YBbXRdNSx4X8',
      },
    },
  },
};

export default variables;



// WEBPACK FOOTER //
// ./src/store/modules/variables.js